'use client'

import { createContext } from 'react'

const DEFAULT_ERROR = new Error('Implement this before using it')

export type SortContextType = {
  indexes: Record<string, number>
  items: Array<string>
  addItem(id: string, index: number): void
  removeItem(id: string): void
}

const Context = createContext<SortContextType>({
  indexes: {},
  items: [],
  addItem() {
    throw DEFAULT_ERROR
  },
  removeItem() {
    throw DEFAULT_ERROR
  },
})

export default Context
